import type { ComponentType } from 'react';
import { File, FileCode, FileImage, FileSpreadsheet, FileText } from 'lucide-react';

type IconComponent = ComponentType<{ className?: string }>;

/** Иконка вложения по типу файла (расширение / MIME) — как на макетах (png/pdf/doc/sql/…). */
export function attachmentIcon(fileName: string, contentType?: string | null): IconComponent {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
  const ct = (contentType ?? '').toLowerCase();

  if (ct.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp'].includes(ext)) {
    return FileImage;
  }
  if (ct === 'application/pdf' || ['pdf', 'doc', 'docx', 'odt', 'rtf'].includes(ext)) {
    return FileText;
  }
  if (['xls', 'xlsx', 'csv', 'ods'].includes(ext)) {
    return FileSpreadsheet;
  }
  if (['sql', 'json', 'xml', 'js', 'ts', 'html', 'css', 'sh', 'yml', 'yaml'].includes(ext)) {
    return FileCode;
  }
  return File;
}
